{
	"type": "symbol",
	"minzoom": 8,
	"layout": {
		"icon-image": [
			"match",
			["get", "poitype"],
			["Camping Ground", "Picnic Area"],
			"rlgsp:recreation_picnic",
			"Park",
			"rlgsp:recreation_park",
			["Swimming Pool", "Swimming Pool Facility"],
			"rlgsp:recreation_swimming",
			"rlgsp:recreation_sporting"
		],
		"icon-overlap": "cooperative"
	},
	"paint": {}
}
